module.exports = __webpack_public_path__ + "img/pad-fill-profile-chart-slide3.28de389d.gif";